import ChevronLeftSvg from '@assets/images/svg/chevron-left.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface ChevronLeftIconProps {
    size?: number;
    color?: string;
}

export const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({
    size = 32,
    color = '#333333',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <ChevronLeftSvg width={size} height={size} color={color} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default ChevronLeftIcon;
